import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// MSAL imports
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig'; 
import { MsalProvider } from '@azure/msal-react';

export const msalInstance = new PublicClientApplication(msalConfig);

// MsalProvider calls instance.initialize() and instance.handleRedirectPromise()
// internally on mount, so those no longer need to be called manually here.
// Account storage events (cross-tab sync) are also always enabled as of
// @azure/msal-browser v5, so enableAccountStorageEvents() is no longer needed either.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MsalProvider instance={msalInstance}>
      <App/>
    </MsalProvider>
);
